import i18n from "i18next";
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next} from "react-i18next";
import en from './locales/en/en.json';
import lv from './locales/lv/lv.json';
import lt from './locales/lt/lt.json';
import et from './locales/est/et_EE.json';
import de from "./locales/de/de.json";
import it from "./locales/it/it.json";
import pl from "./locales/pl/pl.json";
import fr from "./locales/fr/fr.json";
import uk from "./locales/ua/uk.json";


i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    fallbackLng: ['de','en','lv','lt','et','it', 'pl','fr','uk'],
    debug: true,
    detection: {
        order: ['navigator', 'cookie'],
        cache: ['cookie'],
    },
    interpolation: {
        escapeValue: false,
    },
    resources: {
        en: {
            translation: en
        },
        lv:{
            translation: lv
        },
        lt:{
            translation: lt
        },
        et:{
            translation: et
        },
        de :{
            translation: de
        },
        it :{
            translation: it
        },
        pl :{
            translation: pl
        },
        fr :{
            translation: fr
        },
        uk :{
            translation: uk
        }
    },
})
export default i18n;